module.exports = __webpack_public_path__ + "img/right.3a26c9cd.jpg";